import { render, staticRenderFns } from "./UploadFiles2.vue?vue&type=template&id=386043a1&scoped=true"
import script from "./UploadFiles2.vue?vue&type=script&lang=js"
export * from "./UploadFiles2.vue?vue&type=script&lang=js"
import style1 from "./UploadFiles2.vue?vue&type=style&index=1&id=386043a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386043a1",
  null
  
)

export default component.exports